<template>
  <ParentNode
    :source-connection-active="sourceConnectionActive"
    :target-connection-active="targetConnectionActive"
    :type="type"
    :data="data"
    :dimensions="dimensions">
    <template #body>
      <div :class="{ 'relative bottom-3': data.type == 'extractor' }">
        <div v-if="data.type == 'extractor'" class="w-full flex">
          <PlaybookExtractorIcon class="mx-auto relative top-3 -z-10 w-8 h-8" />
        </div>

        <div
          :style="{ width: `${dimensions.w}px`, height: `${dimensions.h}px` }"
          class="h-6 shadow-lg items-center text-center whitespace-nowrap flex justify-center border border-dashed border-black rounded-full bg-white px-2">
          {{
            data.type == "extractor"
              ? data.values.sub_item.replace("_", " ").replace("_child_", "'s ")
              : data.type == "condition"
                ? data.values.condition_value
                : data.values?.operator
          }}
        </div>
      </div>
    </template>
  </ParentNode>
</template>

<script>
import ParentNode from "./ParentNode.vue"

import PlaybookExtractorIcon from "@/components/shared/icons/PlaybookExtractorIcon.vue"

export default {
  components: { ParentNode, PlaybookExtractorIcon },
  props: { data: null, type: null, dimensions: null, sourceConnectionActive: null, targetConnectionActive: null },
  emits: [],
  data() {
    return {}
  },
  watch: {},

  created() {},

  methods: {}
}
</script>

<style scoped>
.custom-border {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='black' stroke-width='4' stroke-dasharray='8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
}
</style>
